import { Scroll } from '../_app/cuchillo/scroll/Scroll';
import Scroll_Item from '../_app/cuchillo/scroll/Scroll_Item';

class ScrollItem__BlockAccordions extends Scroll_Item {
    //==================================================================================================================
    //          CONSTRUCTOR
    //==================================================================================================================
    constructor(__link, __index, __scroller) {
        super(__link, __index, __scroller);

        this.onShow = () => {};
        this.onHide = () => {};
        this.onMove = () => {};
    }

    resize(__w, __h) {
        super.resize(__w, __h);
    }

    dispose() {
        super.dispose();
    }
}

Scroll._registerClass('BlockAccordions', ScrollItem__BlockAccordions);

export default ScrollItem__BlockAccordions;
